import { createI18n } from 'vue-i18n'
import zh from './modules/zh'
import en from './modules/en'
import pt from './modules/pt'
import es from './modules/es'
import de from './modules/de'
import nl from './modules/nl'
import sv from './modules/sv'
import fr from './modules/fr'
const lang = localStorage.getItem('language') ?? 'es'

const i18n = createI18n({
  legacy: false, // 如果要支持 compositionAPI，此项必须设置为 false
  locale: lang, // 设置语言类型
  fallbackLocale: 'en',
  globalInjection: true, // 全局注册$t方法
  messages: {
    zh,
    en,
    pt,
    es,
    de,
    nl,
    sv,
    fr
  }
})

export default i18n
